import axios from "../../services/axios";
import { api_version } from "../../static";
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetchAppMetadata = async ({ aController }) => {
  try {
    const response = await axios.get(`${BASE_URL}/app_metadata`, {
      signal: aController.signal,
    });

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

export const fetchReportFilterMetadata = async ({
  aController,
  project_id = "faninsights",
}) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/${api_version}/${project_id}/filters`,
      {
        signal: aController.signal,
      }
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;
    console.log(error);
    return {
      error: {
        message:
          error?.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};
